import { createJSONStorage, persist } from "zustand/middleware";

import { create } from "zustand";

export const useUserStore = create(
  persist(
    (set) => ({
      hasSetpassword: false,
      search: "",
      resetPageNumber: false,
      resetPageNumberHandler: () =>
        set((state) => ({ resetPageNumber: !state.resetPageNumber })),
      isLoggedIn: false,
      user: null,
      activeRole: null,
      hasLoggedInBefore: null,
      isImpersonating: false,
      currentPath: "",
      dashboardPath: "",
      clanId: "",
      type: "",
      inviteId: null,
    }),
    {
      name: "user",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export function getUserRole() {
  return useUserStore.getState().activeRole;
}

export function getUserData() {
  return useUserStore.getState().user;
}

export function getCurrentPath() {
  return useUserStore.getState().currentPath;
}

export function getSearchQuery() {
  return useUserStore.getState().search;
}

export function getUserType() {
  return useUserStore.getState().type;
}

export function getDashboardPath() {
  return useUserStore.getState().dashboardPath;
}

